module.exports = __webpack_public_path__ + "static/media/Tile HV.484a53d1.jpg";